import Board from '../../types/Board';

class TaflBoard extends Board {
  static _7_brandubh = [ // Irish
    [' ', ' ', ' ', 'a', ' ', ' ', ' '],
    [' ', ' ', ' ', 'a', ' ', ' ', ' '],
    [' ', ' ', ' ', 'd', ' ', ' ', ' '],
    ['a', 'a', 'd', 'd k', 'd', 'a', 'a'],
    [' ', ' ', ' ', 'd', ' ', ' ', ' '],
    [' ', ' ', ' ', 'a', ' ', ' ', ' '],
    [' ', ' ', ' ', 'a', ' ', ' ', ' '],
  ]

  static _9_tablut = [ // Saami
    [' ', ' ', ' ', 'a', 'a', 'a', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' '],
    ['a', ' ', ' ', ' ', 'd', ' ', ' ', ' ', 'a'],
    ['a', 'a', 'd', 'd', 'd k', 'd', 'd', 'a', 'a'],
    ['a', ' ', ' ', ' ', 'd', ' ', ' ', ' ', 'a'],
    [' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', 'a', 'a', 'a', ' ', ' ', ' '],
  ]

  static _11_classic = [
    [' ', ' ', ' ', 'a', 'a', 'a', 'a', 'a', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
    ['a', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', 'a'],
    ['a', ' ', ' ', ' ', 'd', 'd', 'd', ' ', ' ', ' ', 'a'],
    ['a', 'a', ' ', 'd', 'd', 'd k', 'd', 'd', ' ', 'a', 'a'],
    ['a', ' ', ' ', ' ', 'd', 'd', 'd', ' ', ' ', ' ', 'a'],
    ['a', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', 'a'],
    [' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', 'a', 'a', 'a', 'a', 'a', ' ', ' ', ' '],
  ]

  static _11_line = [
    [' ', ' ', ' ', 'a', 'a', 'a', 'a', 'a', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' '],
    ['a', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', 'a'],
    ['a', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', 'a'],
    ['a', 'a', 'd', 'd', 'd', 'd k', 'd', 'd', 'd', 'a', 'a'],
    ['a', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', 'a'],
    ['a', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', 'a'],
    [' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', 'a', 'a', 'a', 'a', 'a', ' ', ' ', ' '],
  ]

  static _11_tawlbwrdd = [ // welsh
    [' ', ' ', ' ', ' ', 'a', 'a', 'a', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', 'a', ' ', 'a', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' '],
    ['a', 'a', ' ', ' ', 'd', 'd', 'd', ' ', ' ', 'a', 'a'],
    ['a', ' ', 'a', 'd', 'd', 'd k', 'd', 'd', 'a', ' ', 'a'],
    ['a', 'a', ' ', ' ', 'd', 'd', 'd', ' ', ' ', 'a', 'a'],
    [' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', 'a', ' ', 'a', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', 'a', 'a', 'a', ' ', ' ', ' ', ' '],
  ]

  static _11_lewiss = [ // welsh
    [' ', ' ', ' ', ' ', 'a', 'a', 'a', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', 'a', 'a', 'a', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' '],
    ['a', 'a', ' ', ' ', ' ', 'd', ' ', ' ', ' ', 'a', 'a'],
    ['a', 'a', 'd', 'd', 'd', 'd k', 'd', 'd', 'd', 'a', 'a'],
    ['a', 'a', ' ', ' ', ' ', 'd', ' ', ' ', ' ', 'a', 'a'],
    [' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', 'a', 'a', 'a', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', 'a', 'a', 'a', ' ', ' ', ' ', ' '],
  ]

  static _13_parlett = [ // Parlett
    [' ', ' ', ' ', ' ', 'a', 'a', 'a', 'a', 'a', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'a', ' ', 'a', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' ', ' '],
    ['a', ' ', ' ', ' ', 'd', ' ', ' ', ' ', 'd', ' ', ' ', ' ', 'a'],
    ['a', 'a', ' ', ' ', ' ', 'd', 'd', 'd', ' ', ' ', ' ', 'a', 'a'],
    ['a', ' ', 'a', 'd', ' ', 'd', 'd k', 'd', ' ', 'd', 'a', ' ', 'a'],
    ['a', 'a', ' ', ' ', ' ', 'd', 'd', 'd', ' ', ' ', ' ', 'a', 'a'],
    ['a', ' ', ' ', ' ', 'd', ' ', ' ', ' ', 'd', ' ', ' ', ' ', 'a'],
    [' ', ' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'a', ' ', 'a', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', 'a', 'a', 'a', 'a', 'a', ' ', ' ', ' ', ' '],
  ]

  static _15_damienwalker = [ // Damien Walker
    [' ', ' ', ' ', ' ', ' ', 'a', 'a', 'a', 'a', 'a', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', 'a', 'a', 'a', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
    ['a', ' ', ' ', ' ', ' ', ' ', 'd', 'd', 'd', ' ', ' ', ' ', ' ', ' ', 'a'],
    ['a', 'a', ' ', ' ', ' ', 'd', ' ', 'd', ' ', 'd', ' ', ' ', ' ', 'a', 'a'],
    ['a', 'a', 'a', 'a', 'd', 'd', 'd', 'd k', 'd', 'd', 'd', 'a', 'a', 'a', 'a'],
    ['a', 'a', ' ', ' ', ' ', 'd', ' ', 'd', ' ', 'd', ' ', ' ', ' ', 'a', 'a'],
    ['a', ' ', ' ', ' ', ' ', ' ', 'd', 'd', 'd', ' ', ' ', ' ', ' ', ' ', 'a'],
    [' ', ' ', ' ', ' ', ' ', ' ', ' ', 'd', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', ' ', 'a', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', ' ', 'a', 'a', 'a', ' ', ' ', ' ', ' ', ' ', ' '],
    [' ', ' ', ' ', ' ', ' ', 'a', 'a', 'a', 'a', 'a', ' ', ' ', ' ', ' ', ' '],
  ]
}

export default TaflBoard;
